// extracted by mini-css-extract-plugin
export default {"cls1":"PaymentChannelViewPayor-Loading_cls1__O7Pho","cls2":"PaymentChannelViewPayor-Loading_cls2__hpH+2 PaymentChannelViewPayor-Loading_cls1__O7Pho"};